// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateAlertRuleMutationVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  name: Types.Scalars["String"]["input"];
  serverId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  checkKinds?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
  destinationIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type CreateAlertRuleMutation = {
  __typename?: "Mutation";
  createAlertRule?: { __typename?: "AlertRule"; id: string } | null;
};

export type UpdateAlertRuleMutationVariables = Types.Exact<{
  alertRuleId: Types.Scalars["ID"]["input"];
  name?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  serverId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  checkKinds?: Types.InputMaybe<
    Array<Types.Scalars["String"]["input"]> | Types.Scalars["String"]["input"]
  >;
  destinationIds?: Types.InputMaybe<
    Array<Types.Scalars["ID"]["input"]> | Types.Scalars["ID"]["input"]
  >;
}>;

export type UpdateAlertRuleMutation = {
  __typename?: "Mutation";
  updateAlertRule?: { __typename?: "AlertRule"; id: string } | null;
};

export type DeleteAlertRuleMutationVariables = Types.Exact<{
  alertRuleId: Types.Scalars["ID"]["input"];
}>;

export type DeleteAlertRuleMutation = {
  __typename?: "Mutation";
  deleteAlertRule?: { __typename?: "AlertRule"; id: string } | null;
};

export const CreateAlertRuleDocument = gql`
  mutation CreateAlertRule(
    $organizationSlug: ID!
    $name: String!
    $serverId: ID
    $checkKinds: [String!]
    $destinationIds: [ID!]
  ) {
    createAlertRule(
      organizationSlug: $organizationSlug
      name: $name
      serverId: $serverId
      checkKinds: $checkKinds
      destinationIds: $destinationIds
    ) {
      id
    }
  }
`;
export type CreateAlertRuleMutationFn = Apollo.MutationFunction<
  CreateAlertRuleMutation,
  CreateAlertRuleMutationVariables
>;

/**
 * __useCreateAlertRuleMutation__
 *
 * To run a mutation, you first call `useCreateAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertRuleMutation, { data, loading, error }] = useCreateAlertRuleMutation({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      name: // value for 'name'
 *      serverId: // value for 'serverId'
 *      checkKinds: // value for 'checkKinds'
 *      destinationIds: // value for 'destinationIds'
 *   },
 * });
 */
export function useCreateAlertRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAlertRuleMutation,
    CreateAlertRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAlertRuleMutation,
    CreateAlertRuleMutationVariables
  >(CreateAlertRuleDocument, options);
}
export type CreateAlertRuleMutationHookResult = ReturnType<
  typeof useCreateAlertRuleMutation
>;
export type CreateAlertRuleMutationResult =
  Apollo.MutationResult<CreateAlertRuleMutation>;
export type CreateAlertRuleMutationOptions = Apollo.BaseMutationOptions<
  CreateAlertRuleMutation,
  CreateAlertRuleMutationVariables
>;
export const UpdateAlertRuleDocument = gql`
  mutation UpdateAlertRule(
    $alertRuleId: ID!
    $name: String
    $serverId: ID
    $checkKinds: [String!]
    $destinationIds: [ID!]
  ) {
    updateAlertRule(
      alertRuleId: $alertRuleId
      name: $name
      serverId: $serverId
      checkKinds: $checkKinds
      destinationIds: $destinationIds
    ) {
      id
    }
  }
`;
export type UpdateAlertRuleMutationFn = Apollo.MutationFunction<
  UpdateAlertRuleMutation,
  UpdateAlertRuleMutationVariables
>;

/**
 * __useUpdateAlertRuleMutation__
 *
 * To run a mutation, you first call `useUpdateAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertRuleMutation, { data, loading, error }] = useUpdateAlertRuleMutation({
 *   variables: {
 *      alertRuleId: // value for 'alertRuleId'
 *      name: // value for 'name'
 *      serverId: // value for 'serverId'
 *      checkKinds: // value for 'checkKinds'
 *      destinationIds: // value for 'destinationIds'
 *   },
 * });
 */
export function useUpdateAlertRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAlertRuleMutation,
    UpdateAlertRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAlertRuleMutation,
    UpdateAlertRuleMutationVariables
  >(UpdateAlertRuleDocument, options);
}
export type UpdateAlertRuleMutationHookResult = ReturnType<
  typeof useUpdateAlertRuleMutation
>;
export type UpdateAlertRuleMutationResult =
  Apollo.MutationResult<UpdateAlertRuleMutation>;
export type UpdateAlertRuleMutationOptions = Apollo.BaseMutationOptions<
  UpdateAlertRuleMutation,
  UpdateAlertRuleMutationVariables
>;
export const DeleteAlertRuleDocument = gql`
  mutation DeleteAlertRule($alertRuleId: ID!) {
    deleteAlertRule(alertRuleId: $alertRuleId) {
      id
    }
  }
`;
export type DeleteAlertRuleMutationFn = Apollo.MutationFunction<
  DeleteAlertRuleMutation,
  DeleteAlertRuleMutationVariables
>;

/**
 * __useDeleteAlertRuleMutation__
 *
 * To run a mutation, you first call `useDeleteAlertRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertRuleMutation, { data, loading, error }] = useDeleteAlertRuleMutation({
 *   variables: {
 *      alertRuleId: // value for 'alertRuleId'
 *   },
 * });
 */
export function useDeleteAlertRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteAlertRuleMutation,
    DeleteAlertRuleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteAlertRuleMutation,
    DeleteAlertRuleMutationVariables
  >(DeleteAlertRuleDocument, options);
}
export type DeleteAlertRuleMutationHookResult = ReturnType<
  typeof useDeleteAlertRuleMutation
>;
export type DeleteAlertRuleMutationResult =
  Apollo.MutationResult<DeleteAlertRuleMutation>;
export type DeleteAlertRuleMutationOptions = Apollo.BaseMutationOptions<
  DeleteAlertRuleMutation,
  DeleteAlertRuleMutationVariables
>;
